"use client";

import { BlogLink, Content, Header } from "@/components/shared/public/blogs";
import { useTranslations } from "next-intl";
import {
  header,
  section1,
  section2,
  section3,
} from "../../../../../../public/images/blogs/factsheetAndExpose";

export default function BlogContent() {
  const t = useTranslations("blogs.factsheetAndExpose");

  return (
    <>
      <Header
        title={t("header.title")}
        text={t("header.text")}
        src={header}
        alt={t("header.imageAlt")}
      />
      <div className="gs--blog-body flex flex-col gap-10 py-16">
        <Content
          title={t("sections.section1.title")}
          text={t.rich("sections.section1.text", {
            br: () => <br />,
            link: (chunks) => (
              <BlogLink href="/blog/neubauprojekt">{chunks}</BlogLink>
            ),
            link2: (chunks) => (
              <BlogLink href="/blog/factsheet">{chunks}</BlogLink>
            ),
          })}
          src={section1}
          alt={t("sections.section1.imageAlt")}
          imageLeft={true}
        />
        <Content
          title={t("sections.section2.title")}
          text={t.rich("sections.section2.text", {
            br: () => <br />,
            link: (chunks) => (
              <BlogLink href="/blog/expose">{chunks}</BlogLink>
            ),
          })}
          src={section2}
          alt={t("sections.section2.imageAlt")}
        />
        <Content
          title={t("sections.section3.title")}
          text={t.rich("sections.section3.text", {
            br: () => <br />,
            link: (chunks) => (
              <BlogLink href="/blog/home-staging">{chunks}</BlogLink>
            ),
          })}
          src={section3}
          alt={t("sections.section3.imageAlt")}
          imageLeft={true}
          disclaimer="default"
        />
      </div>
    </>
  );
}
